import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ContactApiService } from 'src/app/API/contactapi.service';

@Component({
  selector: 'InventorySettings',
  templateUrl: './InventorySettings.component.html'
})

export class InventorySettingsComponent {
  
  constructor(
    public dialog: MatDialog,
     private contactapi: ContactApiService,
  ) {
   
  }

  divisions = ['Home Program', 'Main Centre', 'East Unit', 'West Unit', 'North Unit', 'Off Unit', 'South Unit'];
  // userList = [
  //   { id: 1, name: 'User 1' },
  //   { id: 2, name: 'User 2' },
  //   { id: 3, name: 'User 3' }
  // ];
  userList = [];
  
  ngOnInit() {
     let userType = { str: 'User' };
      this.contactapi.GetContactDetailsByUserType(userType
      ).subscribe(list => {
        this.userList = list;
      });
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode != 46 && charCode != 40 && charCode != 41) {
      return false;
    }
    return true;
  }
}